import { BdArrayUtil } from '@bindoc-projects/util-domain-lib';
import type {
  FilterConditionPluginSpecification,
} from '../filter.plugin';
import {
  FilterConditionPluginImpl
} from '../filter.plugin';
import type {
  BdCondition,
} from '@bindoc-projects/condition-domain-lib';
import {
  BdContentCondition,
} from '@bindoc-projects/condition-domain-lib';
import type { AtVirtualClinicSaps3Zutransferierung } from '@bindoc-projects/virtual-clinic-domain-lib';

export const AT_SAPS3_ZUTRANSFERIERUNG_CONDITION_ID = 'saps3Zutransferierung';
export const AtFilterConditionSaps3ZutransferierungPluginType: FilterConditionPluginSpecification<
  AtVirtualClinicSaps3Zutransferierung[],
  AtFilterConditionSaps3ZutransferierungDto,
  AtSaps3ZutransferierungCondition
> = {
  type: 'saps3Zutransferierung',
  category: 'case',
  displayName: { de: 'SAPS3: Zutransferierung' },
  sortingIndex: 21,
  occurrence: 'single',
  fromObject(
    obj: AtFilterConditionSaps3ZutransferierungDto,
  ): FilterConditionPluginImpl<AtVirtualClinicSaps3Zutransferierung[]> {
    return new AtFilterConditionSaps3ZutransferierungPlugin(
        obj.saps3Zutransferierung,
      );
  },
  fromCondition(
    jsonObj: AtSaps3ZutransferierungCondition,
  ): FilterConditionPluginImpl<AtVirtualClinicSaps3Zutransferierung[]> {
    return new AtFilterConditionSaps3ZutransferierungPlugin(jsonObj.includes ?? []);
  },
  newInstance(): FilterConditionPluginImpl<AtVirtualClinicSaps3Zutransferierung[]> {
    return new AtFilterConditionSaps3ZutransferierungPlugin([]);
  },
};

export class AtFilterConditionSaps3ZutransferierungPlugin extends FilterConditionPluginImpl<
  AtVirtualClinicSaps3Zutransferierung[],
  AtFilterConditionSaps3ZutransferierungDto
> {
  static override Specification: FilterConditionPluginSpecification<
    AtVirtualClinicSaps3Zutransferierung[],
    AtFilterConditionSaps3ZutransferierungDto,
    AtSaps3ZutransferierungCondition
  > = AtFilterConditionSaps3ZutransferierungPluginType;

  constructor(
    protected saps3Zutransferierung: AtVirtualClinicSaps3Zutransferierung[],
  ) {
    super(AtFilterConditionSaps3ZutransferierungPluginType.type);
  }

  clone(): AtFilterConditionSaps3ZutransferierungPlugin {
    return new AtFilterConditionSaps3ZutransferierungPlugin([
      ...this.saps3Zutransferierung,
    ]);
  }

  override equals(
    other: AtFilterConditionSaps3ZutransferierungPlugin,
  ): boolean {
    return (
      super.equals(other) &&
      BdArrayUtil.equals(
        this.saps3Zutransferierung,
        other.saps3Zutransferierung,
      )
    );
  }

  override validationToText(): string {
    if (this.saps3Zutransferierung.length === 0) {
      return 'Mindestens eine Zutransferierung auswählen';
    } else {
      return '';
    }
  }

  toCondition(): BdCondition | null {
    return new AtSaps3ZutransferierungCondition(this.saps3Zutransferierung, []);
  }

  toText(): string | null {
    return this.saps3Zutransferierung.length === 1
      ? 'eine Zutransferierung'
      : `${this.saps3Zutransferierung.length} Zutransferierungen`;
  }

  toJSON(): AtFilterConditionSaps3ZutransferierungDto | null {
    return {
      type: this.type,
      saps3Zutransferierung: this.saps3Zutransferierung,
    };
  }

  toValue(): AtVirtualClinicSaps3Zutransferierung[] {
    return this.saps3Zutransferierung;
  }
}

export class AtSaps3ZutransferierungCondition extends BdContentCondition<AtVirtualClinicSaps3Zutransferierung> {
  constructor(
    includes: AtVirtualClinicSaps3Zutransferierung[],
    excludes: AtVirtualClinicSaps3Zutransferierung[],
  ) {
    super(AT_SAPS3_ZUTRANSFERIERUNG_CONDITION_ID, includes, excludes);
  }
}

interface AtFilterConditionSaps3ZutransferierungDto {
  type: string;
  saps3Zutransferierung: AtVirtualClinicSaps3Zutransferierung[];
}
